// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"201":"component---src-gatsby-entities-page-tsx","336":"component---node-modules-shapeable-gatsby-theme-shapeable-web-src-components-404-tsx"}[chunkId] + "-" + {"201":"149219e7094988613e07","336":"ad526a6d2a12efe40578"}[chunkId] + ".js";
};